import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { ProjectShowcase } from './components/ProjectShowcase';
import { About } from './components/About';
import { CrobotShowcase } from './components/CrobotShowcase';
import { PressRecognition } from './components/PressRecognition';
import { Contact } from './components/Contact';
import { ScrollProgress } from './components/ScrollProgress';
import { ContactWidget } from './components/ContactWidget';
import { ScrollLine } from './components/ScrollLine';
import { Preloader } from './components/Preloader';
import { LanguageProvider } from './lib/i18n';
export function App() {
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      document.documentElement.style.setProperty('--mouse-x', `${e.clientX}px`);
      document.documentElement.style.setProperty('--mouse-y', `${e.clientY}px`);
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);
  return <LanguageProvider data-id="element-0">
      <div className="relative min-h-screen bg-background text-primary" data-id="element-1">
        <Preloader data-id="element-2" />
        <ScrollProgress data-id="element-3" />
        <ScrollLine data-id="element-4" />
        <div className="noise-overlay" data-id="element-5" />
        <div className="cursor-glow hidden md:block" data-id="element-6" />
        <ContactWidget data-id="element-7" />
        <main className="relative z-10" data-id="element-8">
          <Hero data-id="element-9" />
          <Marquee data-id="element-10" />
          <ProjectShowcase data-id="element-11" />
          <CrobotShowcase data-id="element-12" />
          <PressRecognition data-id="element-13" />
          <About data-id="element-14" />
          <Contact data-id="element-15" />
        </main>
      </div>
    </LanguageProvider>;
}